<template>
	<span :class="classes">{{ articleDate }}</span>
</template>

<script setup lang="ts">
import spacetime, { Format } from 'spacetime';
import { computed } from 'vue';
import { CustomSpacetimeFormat } from 'types/spacetime-formats';

interface Props {
	dateString: string;
	classes?: string;
	format?: Format;
}

const props = withDefaults(defineProps<Props>(), {
	format: CustomSpacetimeFormat.MONTH_SHORT_DATE_PAD_YEAR,
	classes: undefined
});

const articleDate = computed((): string => {
	const dateString = props.dateString;
	if (dateString) {
		return spacetime(dateString).format(props.format);
	}
	return '';
});
</script>
